import React from "react";
import {
  FaTwitter,
  FaLinkedin,
  FaGithub,
  // FaInstagram
} from "react-icons/fa";
import { SiFreelancer } from "react-icons/si";

const Footer = () => {
  const year = new Date();

  return (
    <>
      <footer
        className="w-full text-center p-6 bg-accent"
        style={{ backgroundColor: "#313131" }}
      >
        <div className="w-full h-[2px] bg-gray-600"></div>
        <div className="flex flex-col md:flex-row items-center justify-between mt-4">
          <p>&copy; Copyright All Rights Reserved {year.getFullYear()}</p>
          <div>
            <div className="flex items-center justify-center mb-2 mt-2">
              <a
                className="inline-block mx-2"
                href="https://twitter.com/MujDeveloper"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter className="text-2xl text-blue-600" />
              </a>
              <a
                className="inline-block mx-2"
                href="https://www.linkedin.com/in/mucahid-developer/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="text-2xl text-blue-400" />
              </a>
              <a
                className="inline-block mx-2"
                href="https://github.com/MucahidDeveloper"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub className="text-2xl text-black" />
              </a>
              <a
                className="inline-block mx-2"
                href="https://www.freelancer.com/u/mucadeveloper"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiFreelancer className="text-2xl text-blue-600" />
              </a>
              {/* <a
            className="inline-block mx-2"
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="text-2xl text-pink-500" />
          </a> */}
            </div>
            <div className="hidden  md:flex items-center justify-center mb-2 flex-wrap">
              {/* <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://www.fiverr.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Fiverr
          </a>
          <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://www.upwork.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            UpWork
          </a> */}

              {/* <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://themeforest.net/"
            target="_blank"
            rel="noopener noreferrer"
          >
            ThemeForest
          </a>
          <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://remotehub.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            RemoteHub
          </a>
          <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://dribbble.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dribbble
          </a> */}
              <a
                className="text-xl inline-bloc mx-6 text-neutral"
                href="https://drive.google.com/file/d/1nwxhvMruVM-n4slHe7xuPrNeNXzizlVH/view"
                target="_blank"
                rel="noopener noreferrer"
              >
                Resume
              </a>
            </div>
          </div>
          <p>
            Developed by{" "}
            <a
              href="https://www.linkedin.com/in/mucahid-developer/"
              className="text-primary hover:underline"
              target="blank"
            >
              Mujahed ELHADDAD
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
